var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShields(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.0377C6 9.63615 7.13615 8.5 8.53766 8.5V8.5C12.7984 8.5 17.0118 7.60586 20.9054 5.8754L22.6627 5.09437C23.5141 4.71597 24.4859 4.71597 25.3373 5.09437L27.0946 5.8754C30.9882 7.60586 35.2016 8.5 39.4623 8.5V8.5C40.8639 8.5 42 9.63615 42 11.0377V33.2567C42 34.6501 41.2748 35.9432 40.0858 36.6698L26.0858 45.2253C24.8054 46.0078 23.1946 46.0078 21.9142 45.2253L7.9142 36.6698C6.72518 35.9432 6 34.6501 6 33.2567V11.0377Z",
    fill: "#7E59EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24.5L22 29.5L31 19.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShields);
export default __webpack_public_path__ + "static/media/shields.1600b539d31a276297e22cc711d7c703.svg";
export { ForwardRef as ReactComponent };